import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {DonationsReport} from 'src/app/shared/Models/DonationsReport'
import {ProjectsService} from 'src/app/shared/API-Service/services/projects.service'
import {RefCodeService} from 'src/app/shared/API-Service/services/RefCode.service'
@Component({
  selector: 'app-donations',
  templateUrl: './donations-reports.component.html',
  styleUrls: ['./donations-reports.component.css']
})
export class DonationsReportComponent implements OnInit {
  ReportsInfo = new DonationsReport()
  currentUser: any;
  projects: any;
  RefCodes:any
  GroupByProject:boolean=false
  GroupByRefCode:boolean=false
  GroupBy=[{
    id:1,
    name:'المشروع'
  },
  {
    id:2,
    name:'الكود المرجعي'
  }
]
  constructor(private router: Router,private ProjectsService:ProjectsService,private RefCodeService :RefCodeService) {
  
  }
  ngOnInit(): void {
    this.GetProjects();
    this.GetRefCodes();
  }
  GetProjects(){
    this.ProjectsService.GetProjects().subscribe(res=>{
      this.projects=res.data
    })
  }
  GetRefCodes(){
    this.RefCodeService.GetRefCodes().subscribe(res=>{
      this.RefCodes=res.data
    })
  }
  SelectRefCode(event){
    this.ReportsInfo.RefCodeID = parseInt(event) 
    this.ReportsInfo.RefCode = this.RefCodes.find(x => x.id == event)?.refCode
   }
   SelectGroupBy(event){
    if(event==1){
      this.GroupByProject=true
      this.GroupByRefCode=false
    
    }
   else if(event==2){
      this.GroupByProject=false
      this.GroupByRefCode=true
    }
    else{
      this.GroupByProject=true
      this.GroupByRefCode=false
    }
   }
  SelectProject(event){
    this.ReportsInfo.Project = parseInt(event) 
    this.ReportsInfo.ProjectName = this.projects.find(x => x.id == event)?.title
   }

  Viewreports() {
   if(this.GroupByRefCode){
    localStorage["ReportName"] = "DonationRefcode";
  }
  else{
    localStorage["ReportName"] = "DonationsReport";
  }
  
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));
    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }

}
